import {memo, ReactNode} from 'react';
import styles from './PageContainer.module.scss';

export const ClassicPageContainer = memo(({children}: {children: ReactNode}) => {
  return <div className={`page-container ${styles.containerClassic}`}>{children}</div>;
});
ClassicPageContainer.displayName = 'ClassicPageContainer';
